import React, { createContext, useCallback, useContext, useState } from 'react';
import { mapAppointmentRequestDoctorOptions } from '../../../../utils/staffDoctorSelect';

export const tab = Object.freeze({
  MAIN_INFO: 'Main Information',
  ATTACHMENTS: 'Attachments',
});

const AppointmentRequestModalContext = createContext({
  isAppointmentRequestModalOpen: false,
  openAppointmentRequestModal: () => {},
  closeAppointmentRequestModal: () => {},
  appointmentRequestData: {},
  handleSetAppointmentRequestData: () => {},
  activeTab: tab.MAIN_INFO,
  setActiveTab: () => {},
  doctors: [],
  handelSetDoctors: () => {},
  isMessageModalOpen: false,
  setIsMessageModalOpen: () => {},
  handleRefetchAppointmentRequests: () => {},
});

export const AppointmentRequestModalProvider = ({
  children,
  handleRefetchAppointmentRequests,
}) => {
  const [isAppointmentRequestModalOpen, setIsAppointmentRequestModalOpen] =
    useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [appointmentRequestData, setAppointmentRequestData] = useState({});
  const [activeTab, setActiveTab] = useState(tab.MAIN_INFO);
  const [doctors, setDoctors] = useState([]);

  const openAppointmentRequestModal = useCallback((tabToOpen) => {
    setIsAppointmentRequestModalOpen(true);
    tabToOpen && setActiveTab(tabToOpen);
  }, []);

  const closeAppointmentRequestModal = useCallback(() => {
    setIsAppointmentRequestModalOpen(false);
    setAppointmentRequestData({});
    setActiveTab(tab.MAIN_INFO);
  }, []);

  const handleSetAppointmentRequestData = useCallback((data) => {
    const { date, time, ...rest } = data;
    setAppointmentRequestData({
      ...rest,
      dateTime: `${date} ${time}`,
    });
  }, []);

  const handleSetDoctors = useCallback((newDoctors) => {
    setDoctors(mapAppointmentRequestDoctorOptions(newDoctors));
  }, []);

  return (
    <AppointmentRequestModalContext.Provider
      value={{
        isAppointmentRequestModalOpen,
        openAppointmentRequestModal,
        closeAppointmentRequestModal,
        appointmentRequestData,
        handleSetAppointmentRequestData,
        activeTab,
        setActiveTab,
        doctors,
        handleSetDoctors,
        isMessageModalOpen,
        setIsMessageModalOpen,
        handleRefetchAppointmentRequests,
      }}
    >
      {children}
    </AppointmentRequestModalContext.Provider>
  );
};

export const useAppointmentRequestModalContext = () => {
  return useContext(AppointmentRequestModalContext);
};
